import script from "./ButtonPlus.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPlus.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPlus.vue?vue&type=style&index=0&id=19c129ad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c129ad"]])

export default __exports__